import React from 'react';

import {Helmet} from 'views/module';

import CaregiverListScene from 'views/scenes/caregiver/list/CaregiverList';

const CaregiverList = (props) => {
  return (
    <>
      <Helmet>
        <title>Quilt: Caregiver List</title>
      </Helmet>
      <CaregiverListScene
      />
    </>
  );
};

export default CaregiverList;
